import { type BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent';
import { ref } from 'vue';

/**
 * Composable for NewRelic browser agent functionality
 * Provides a type-safe interface to NewRelic methods
 */
export function useNewRelic() {
  const newRelic = window.newrelic;

  /**
   * Get the raw NewRelic agent instance for advanced usage
   */
  const newRelicBrowserAgent = ref<BrowserAgent>(newRelic);

  /**
   * Report an error to NewRelic
   * @param error - The error to report
   * @param customAttributes - Additional attributes to include with the error
   */
  const noticeError = (error: Error | string, customAttributes?: Record<string, any>) => {
    newRelic.noticeError(error, customAttributes);
  };

  return {
    noticeError,
    newRelicBrowserAgent,
  };
}
